import { Button } from "antd";
import axios from '../../../../context/axiosConfig'
import { useAuth } from "../../../../context/AuthContext";

const GeneratePersonRaport = ({wplywid, personid}) => {
    const { user } = useAuth();
    const generate = async () => {
        try {
            const response = await axios.post(
                "/wplyw/generate/raport/person",
                { wplywid: wplywid, personid: personid, user: user.user.mlg_users_id},
                { responseType: "blob" } // Important to handle file as binary
            );
    
            // Extract filename from Content-Disposition header
            const contentDisposition = response.headers["content-disposition"];
            let filename = `Raport osoby #${personid}`; // Default filename
    
            if (contentDisposition) {
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch && filenameMatch[1]) {
                    filename = filenameMatch[1];
                }
            }
    
            const blob = new Blob([response.data], { type: "application/pdf" });
            const link = document.createElement("a");
    
            // Create a link to the file
            link.href = window.URL.createObjectURL(blob);
            link.download = filename; // Use the extracted or default filename
            link.click();
        } catch (error) {
            console.error("Błąd pobierania pliku:", error);
        }
    };

    return <Button onClick={() => generate()}>Generuj raport osoby</Button>;
};

export default GeneratePersonRaport;